import styled from 'styled-components'

export const Picture = styled.img`
    border-radius: 90%;
    height: 400px;
    width: 400px;

    margin-left: 57%;
    margin-top: 15%;
    margin-bottom: 16%;

    background-image: ${({ backgroundImage }) => `url(${backgroundImage})`}; 
    background-size: cover;


    @media only screen and (max-device-width: 800px) {
        width: 100px;
        margin-left: 65%;
        height: 100px;
    }
`
export const Paragraph = styled.p`
    color: white;
    font-size: 22px;
    text-align: justify;
    width: 600px;
    
    top: 0;
    left: 0;
    right: 0;
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;
    
    padding-right: 15%;
    padding-left: 15%;
    margin-top: 20%;

    @media only screen and (max-device-width: 800px) {
        width: 50%;
        padding-left: 5%;
        margin-left: 1px;
        font-size: 12px;
    }
`
export const Content = styled.div`
    color: white;
    font-size: 22px;
    text-align: justify;

    top: 0;
    left: 0;
    right: 0;

    justify-content: center;
    align-items: center;

    color: white;
    text-align: justify;
   
    padding-right: 15%;
    padding-left: 15%;
    margin-bottom: 5%;

    @media only screen and (max-device-width: 800px) {
        font-size: 14px;
    }
`

export const Titles = styled.h1`
    margin-left: 10%;
   margin-bottom: 5%;


    text-align: center;
    
    color: white;
    border: 10px solid #F26E0E;
    width: max-content;
    height: max-content;
    border-radius: 30px;
    background-color: #F26E0E;

    @media only screen and (max-device-width: 800px) {
        font-size: 16px;
    }

`

export const SubTitles = styled.h1`
    font-size: 18px;
    color: #F26E0E;
    @media only screen and (max-device-width: 800px) {
        font-size: 12px;
    }
`
